/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The live status of participant in meeting
 * @export
 * @enum {string}
 */
export enum LiveAttendanceStatusType {
    Online = 'ONLINE',
    Waiting = 'WAITING',
    Offline = 'OFFLINE'
}

export function LiveAttendanceStatusTypeFromJSON(json: any): LiveAttendanceStatusType {
    return LiveAttendanceStatusTypeFromJSONTyped(json, false);
}

export function LiveAttendanceStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveAttendanceStatusType {
    return json as LiveAttendanceStatusType;
}

export function LiveAttendanceStatusTypeToJSON(value?: LiveAttendanceStatusType | null): any {
    return value as any;
}

